import { BaseController } from '../../../base/controller';

class PartCalculatorController extends BaseController {
  constructor(controllerService, $scope, $rootScope) {
    'ngInject';
    super({ controllerService, $scope, $rootScope });
  }

  $onInit() {
    // fractals of depot are not allowed:
    // - floor them
    // -  show hint with option to check sellFragments
    this.$scope.$watch('vm.modelTransferQuantity', (newValue) => {
      if (!Number.isInteger(this.modelTransferQuantity)) {
        this.modelTransferQuantity = Math.floor(this.modelTransferQuantity);
        this.$rootScope.$broadcast('hasFragments', true);
      }
    });
  }

  // important: form must updates its min and max ranges when model changes
  $onChanges() {
    this.options = {
      min: 0,
      max: this.quantity,
    };
  }

  increase() {
    if (this.modelTransferQuantity < this.quantity) {
      this.modelTransferQuantity = Math.floor(this.modelTransferQuantity) + 1;
    }
  }

  decrease() {
    if (this.modelTransferQuantity > 0) {
      this.modelTransferQuantity = Math.ceil(this.modelTransferQuantity) - 1;
    }
  }

  get increaseDisabled() {
    return this.modelTransferQuantity + 1 > this.options.max;
  }
  get decreaseDisabled() {
    return this.modelTransferQuantity - 1 < this.options.min;
  }
}

export default PartCalculatorController;



// WEBPACK FOOTER //
// ./src/app/common/ui/stockList/partCalculator/partCalculator.controller.js